import script from "./manage-inventory-members.vue?vue&type=script&setup=true&lang=js"
export * from "./manage-inventory-members.vue?vue&type=script&setup=true&lang=js"

import "./manage-inventory-members.vue?vue&type=style&index=0&id=134e2fce&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-134e2fce"]])

export default __exports__